// Report input field types and their configurations
export type ReportInputType =
  | { type: 'startDate' | 'endDate' | 'reportDate'; label?: string }
  | { type: 'portfolioId'; label?: string; allowMultiple?: boolean; allowAll?: boolean };

export interface ReportDefinition {
  reportName: string;
  label: string;
  fileType: 'pdf' | 'xlsx';
  inputs: ReportInputType[];
}

// Define all available reports with their required inputs
export const DNB_CONTRACT_NOTES: ReportDefinition = {
  reportName: "DNB - Contract notes",
  label: "Sluttsedler",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};

export const DNB_BANKKONTOUTDRAG: ReportDefinition = {
  reportName: "DNB - Bankkontoutdrag new",
  label: "Kontoutdrag",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};

export const DNB_KOSTNADSOVERSIKT: ReportDefinition = {
  reportName: "DNB - Kostnadsoversikt",
  label: "Kostnadsoversikt",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};

export const DNB_BEHOLDNINGSRAPPORT: ReportDefinition = {
  reportName: "DNB - Beholdningsrapport",
  label: "Beholdningsrapport",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'reportDate', label: "Rapportdato" }
  ]
};

export const DNB_UTVIKLING_OG_HISTORISK_VERDI: ReportDefinition = {
  reportName: "DNB - Utvikling og historisk verdi",
  label: "Utvikling og historisk verdi",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};

export const DNB_REALIZED_PROFITS: ReportDefinition = {
  reportName: "DNB - Realized profits",
  label: "Realisert avkasting",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};

export const DNB_BEHOLDNING_AGGREGERT: ReportDefinition = {
  reportName: "DNB - Beholdning aggregert",
  label: "Beholdningsrapport",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'reportDate', label: "Rapportdato" }
  ]
};

export const DNB_TRANSAKSJONSRAPPORT_TOT_EXCEL_NEW: ReportDefinition = {
  reportName: "DNB - Transaksjonsrapport tot excel new",
  label: "Transaksjonsrapport (xlsx)",
  fileType: "xlsx",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
}

export const DNB_TRANSAKSJONSOVERSIKT_TOT_NEW: ReportDefinition = {
  reportName: "DNB - Transaksjonsoversikt tot new",
  label: "Transaksjonsrapport",
  fileType: "pdf",
  inputs: [
    { type: 'portfolioId', allowMultiple: true, allowAll: true },
    { type: 'startDate' },
    { type: 'endDate' }
  ]
};
